/* Fluido — visor 3D / 360º del lápiz (three.js r128) */
(function () {
  function init(root) {
    if (!root || root.dataset.mtInit || !window.THREE) return;
    root.dataset.mtInit = '1';
    var T = window.THREE;
    var canvasWrap = root.querySelector('.mt-360__canvas');
    var tips = [].slice.call(root.querySelectorAll('.mt-360__tip'));
    var views = [].slice.call(root.querySelectorAll('[data-view]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var renderer;
    try { renderer = new T.WebGLRenderer({ antialias: true, alpha: true }); }
    catch (e) { root.classList.add('mt-360--sin3d'); return; }
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.NoToneMapping;
    canvasWrap.appendChild(renderer.domElement);

    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(30, 1, 0.1, 100);
    camera.position.set(0, 0, 9.2);

    scene.add(new T.HemisphereLight(0xdfe6ff, 0x1a1a22, 0.75));
    var key = new T.DirectionalLight(0xffffff, 1.1); key.position.set(3, 4, 6); scene.add(key);
    var rim = new T.DirectionalLight(0xd8c3a5, 1.1); rim.position.set(-5, 2, -4); scene.add(rim);
    var fill = new T.DirectionalLight(0x7c9cff, 0.7); fill.position.set(-4, -3, 3); scene.add(fill);

    var pivot = new T.Group(); scene.add(pivot);
    var model = new T.Group(); pivot.add(model);
    model.rotation.z = -0.22;

    var H = 4, D = 4 * 14.5 / 152.6, BT = 0.075, BS = 0.035;
    var loader = new T.TextureLoader();
    fetch(root.dataset.forma).then(function (r) { return r.json(); }).then(function (f) {
      var shape = new T.Shape();
      f.pts.forEach(function (p, i) { var x = p[0] * H, y = p[1] * H; if (i) shape.lineTo(x, y); else shape.moveTo(x, y); });
      var aw = f.aspect * H;

      var body = new T.ExtrudeGeometry(shape, { depth: D - 2 * BT, bevelEnabled: true, bevelThickness: BT, bevelSize: BS, bevelSegments: 10, curveSegments: 6, steps: 1 });
      body.translate(0, 0, -(D - 2 * BT) / 2);
      var metal = new T.MeshStandardMaterial({ color: 0x232428, metalness: 0.45, roughness: 0.5, flatShading: false });
      body.computeVertexNormals();
      model.add(new T.Mesh(body, metal));

      function cap(src, front) {
        var g = new T.ShapeGeometry(shape, 24);
        var pos = g.attributes.position, uv = g.attributes.uv;
        for (var i = 0; i < pos.count; i++) {
          var x = pos.getX(i), y = pos.getY(i);
          uv.setXY(i, x / aw + 0.5, y / H + 0.5);
        }
        uv.needsUpdate = true;
        var tex;
        if (front) {
          var cv = document.createElement('canvas'), ctx = cv.getContext('2d'), im = new Image();
          tex = new T.CanvasTexture(cv);
          im.crossOrigin = 'anonymous';
          var paint = function () {
            if (!im.naturalWidth) return;
            cv.width = im.naturalWidth; cv.height = im.naturalHeight;
            ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(im, 0, 0);
            var k = cv.height / 1654, x = window.mtClockText ? window.mtClockText() : { t: '', d: '' };
            ctx.save(); ctx.translate(30 * k, 1296 * k); ctx.rotate(-Math.PI / 2); ctx.textBaseline = 'top';
            ctx.fillStyle = '#f0f0f5'; ctx.font = '600 ' + (24 * k) + 'px Inter, sans-serif'; ctx.fillText(x.t, 28 * k, 18 * k);
            ctx.fillStyle = '#a0a5af'; ctx.font = '400 ' + (19 * k) + 'px Inter, sans-serif'; ctx.fillText(x.d, 112 * k, 22 * k);
            ctx.restore(); tex.needsUpdate = true; draw();
          };
          im.onload = function () { (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(paint); };
          im.src = src;
          setInterval(paint, 30000);
        } else {
          tex = loader.load(src, function () { draw(); });
        }
        tex.encoding = T.sRGBEncoding;
        tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
        var m = new T.MeshStandardMaterial({ map: tex, transparent: true, alphaTest: 0.4, roughness: front ? 0.4 : 0.5, metalness: front ? 0.0 : 0.25,
          emissive: front ? 0xffffff : 0x000000, emissiveMap: front ? tex : null, emissiveIntensity: front ? 0.08 : 0 });
        var mesh = new T.Mesh(g, m);
        var z = D / 2 + 0.004;
        if (front) mesh.position.z = z;
        else { mesh.rotation.y = Math.PI; mesh.position.z = -z; }
        model.add(mesh);
      }
      cap(root.dataset.front, true);
      cap(root.dataset.back, false);
      root.classList.add('is-ready');
      resize(); draw();
    }).catch(function () { root.classList.add('mt-360--sin3d'); });

    /* puntos de interés (coordenadas del modelo, normal) */
    var spots = tips.map(function (el) {
      var p = el.dataset.pos.split(',').map(Number), n = el.dataset.n.split(',').map(Number);
      return { el: el, p: new T.Vector3(p[0], p[1], p[2]), n: new T.Vector3(n[0], n[1], n[2]) };
    });

    /* interacción */
    var rotY = window.innerWidth < 600 ? -0.15 : -0.5, rotX = 0.08, velY = 0, target = null, dragging = false, lastX = 0, lastY = 0, idle = 0, visible = false;
    var el = renderer.domElement;
    el.style.touchAction = 'pan-y';
    el.addEventListener('pointerdown', function (e) { dragging = true; target = null; lastX = e.clientX; lastY = e.clientY; el.setPointerCapture(e.pointerId); root.classList.add('is-drag'); });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY; lastX = e.clientX; lastY = e.clientY;
      velY = dx * 0.012; rotY += velY; rotX = Math.max(-0.5, Math.min(0.5, rotX + dy * 0.006)); idle = 0;
      root.classList.add('is-used');
    });
    function up() { dragging = false; root.classList.remove('is-drag'); }
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    views.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseFloat(b.dataset.view);
        var k = Math.round((rotY - v) / (2 * Math.PI));
        target = v + k * 2 * Math.PI; velY = 0; idle = 0; rotX = 0.05;
        views.forEach(function (o) { o.classList.toggle('is-active', o === b); });
        root.classList.add('is-used');
      });
    });

    function resize() {
      var w = canvasWrap.clientWidth, h = canvasWrap.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.position.z = w / h < 0.8 ? 11.5 : 9.2;
      camera.updateProjectionMatrix();
    }
    window.addEventListener('resize', function () { resize(); draw(); });

    var v3 = new T.Vector3(), nW = new T.Vector3(), camDir = new T.Vector3();
    function draw() {
      pivot.rotation.y = rotY; pivot.rotation.x = rotX;
      renderer.render(scene, camera);
      var w = canvasWrap.clientWidth, h = canvasWrap.clientHeight;
      spots.forEach(function (s) {
        v3.copy(s.p); model.localToWorld(v3);
        nW.copy(s.n).applyQuaternion(model.getWorldQuaternion(new T.Quaternion()));
        camDir.copy(camera.position).sub(v3).normalize();
        var facing = nW.lengthSq() === 0 ? 1 : nW.dot(camDir);
        v3.project(camera);
        var x = (v3.x * 0.5 + 0.5) * w, y = (-v3.y * 0.5 + 0.5) * h;
        s.el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        s.el.classList.toggle('is-on', facing > (w < 600 ? 0.45 : 0.15));
        s.el.classList.toggle('is-left', x > w - 230);
      });
    }

    function loop() {
      if (!visible) return;
      requestAnimationFrame(loop);
      if (target !== null) { rotY += (target - rotY) * 0.08; if (Math.abs(target - rotY) < 0.001) target = null; }
      else if (!dragging) {
        velY *= 0.94; rotY += velY;
        idle++;
        if (!reduce && idle > 160 && Math.abs(velY) < 0.002) rotY += 0.0045;
      }
      draw();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { var was = visible; visible = e[0].isIntersecting; if (visible && !was) { resize(); loop(); } }, { threshold: 0.05 }).observe(root);
    } else { visible = true; loop(); }
    resize();
  }
  function all() { document.querySelectorAll('[data-mt-360]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
